import React, { useState } from 'react'
import Slider from 'react-slick'
import { Box, Modal, IconButton, Typography } from '@mui/material'
import { Close as CloseIcon } from '@mui/icons-material'
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'
import toast from 'react-hot-toast'

type ImagesCarouselProps = {
  images: string[]
  thumbnails: string[]
  row?: any
  showThumbnail?: boolean
}

function SampleNextArrow(props: any) {
  const { className, style, onClick } = props
  return (
    <Box
      className={className}
      onClick={onClick}
      sx={{
        right: '-40px !important',
      }}
    />
  )
}

function SamplePrevArrow(props: any) {
  const { className, style, onClick } = props
  return (
    <Box
      className={className}
      onClick={onClick}
      sx={{
        left: '-40px !important',
        zIndex: 1024,
      }}
    >
      <p className="bg-red-500">sdadsadasdas</p>
    </Box>
  )
}

const ImagesCarousel: React.FC<ImagesCarouselProps> = ({ row, images, thumbnails, showThumbnail }) => {
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [currentIndex, setCurrentIndex] = useState(0)

  const handleOpenModal = (index: number) => {
    setCurrentIndex(index)
    setIsModalOpen(true)
  }

  const handleCloseModal = () => {
    setIsModalOpen(false)
  }

  const carouselSettings = {
    initialSlide: currentIndex,
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />,
  }

  return (
    <div>
      <div className="flex items-center">
        {/* {thumbnails
          ?.slice(0, 2)
          ?.map((thumbnail, index) => (
            <img key={index} src={thumbnail} alt={`thumbnail-${index}`} className="w-8 h-8 object-cover cursor-pointer mr-1 rounded-lg" onClick={() => handleOpenModal(index)} />
          ))}
        {thumbnails?.length > 2 && (
          <span className="cursor-pointer text-blue-500" onClick={() => handleOpenModal(2)}>
            +{thumbnails?.length - 2}
          </span>
        )} */}
        <span
          className="cursor-pointer text-blue-500"
          onClick={() => {
            if (thumbnails?.length) {
              handleOpenModal(2)
            } else {
              toast('No images found.')
            }
          }}
        >
          {showThumbnail ? <img className="w-[60px] h-[60px] object-cover object-center rounded-lg" src={thumbnails[0] || ''} alt={`${thumbnails?.length}`} /> : thumbnails?.length}
        </span>
      </div>

      <Modal open={isModalOpen} onClose={handleCloseModal} className="relative">
        <Box className="bg-white p-4 rounded-lg  max-w-3xl mx-auto my-20 pb-8">
          <Box className="flex justify-between">
            <Typography variant="h6">{`${thumbnails?.length > 1 ? 'Images' : 'Image'}`}</Typography>
            <IconButton onClick={handleCloseModal}>
              <CloseIcon />
            </IconButton>
          </Box>
          {images?.length > 1 ? (
            <Slider {...carouselSettings}>
              {images?.map((image, index) => (
                <div key={index} className="flex justify-center items-center">
                  <div className="flex justify-center items-center">
                    <img src={image} alt={`carousel-${index}`} className="w-auto h-auto max-h-[calc(100vh-200px)]" />
                  </div>
                </div>
              ))}
            </Slider>
          ) : (
            <div className="flex justify-center items-center">
              <div className="flex justify-center items-center">
                <img src={images && images[0]} alt={row?.id || 'image'} className="w-auto h-auto max-h-[calc(100vh-200px)]" />
              </div>
            </div>
          )}
        </Box>
      </Modal>
    </div>
  )
}

export default ImagesCarousel
